<template>
  <video width="100%" height="100%" controls autoplay>
    <source :src="video.path" type="video/mp4">
    <!-- <source src="movie.ogg" type="video/ogg"> -->
    您的浏览器不支持Video标签。
  </video>
</template>

<script>
export default {
  name: "VideoModule",
  props: ["video"]
};
</script>